import React, { useEffect, useState } from 'react';
import './FlowOfFundsTab.scss';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { FlowOfFundsSubTab } from '../../../enums/flow-of-funds-sub-tab.enum';
import { FlowOfFundsTabs } from './FlowOfFundsTabs';
import { OverallDealStructureSubTab } from './SubTabs/OverallDealStructure/OverallDealStructureSubTab';
import { ThirdPartyPayoffsSubTab } from './SubTabs/ThirdPartyPayoffs/ThirdPartyPayoffsSubTab';
import { VetValueFeesSubTab } from './SubTabs/VetValueFees/VetValueFeesSubTab';
import { LegalFeesSubTab } from './SubTabs/LegalFees/LegalFeesSubTab';
import { WireTransferSummarySubTab } from './SubTabs/WireTransferSummary/WireTransferSummarySubTab';
import { NotificationFlag } from '../../../components/NotificationFlag/NotificationFlag';
import { NotificationFlagsCategories } from '../../../models/NotificationFlags/NotificationFlagsCategories';

export interface FlowOfFundsTabProps {
    engagementId: number;
    party: TimelineParty;
    setSearchParams?: (params: { [key: string]: string }) => void;
    searchParams: URLSearchParams;
}

export const FlowOfFundsTab = (props: FlowOfFundsTabProps) => {
    const [activeSubTab, setActiveSubTab] = useState<FlowOfFundsSubTab>();

    const subTabComponents = [
        {
            id: FlowOfFundsSubTab.OverallDealStructure,
            content: <OverallDealStructureSubTab engagementId={props.engagementId} />,
        },
        {
            id: FlowOfFundsSubTab.ThirdPartyPayoffs,
            content: <ThirdPartyPayoffsSubTab engagementId={props.engagementId} />,
        },
        {
            id: FlowOfFundsSubTab.VetValueFees,
            content: <VetValueFeesSubTab engagementId={props.engagementId} />,
        },
        {
            id: FlowOfFundsSubTab.LegalFees,
            content: <LegalFeesSubTab engagementId={props.engagementId} />,
        },
        {
            id: FlowOfFundsSubTab.WireTransferSummary,
            content: <WireTransferSummarySubTab engagementId={props.engagementId} />,
        },
    ];

    useEffect(() => {
        const requestedSubTab = Number(props.searchParams.get('subtab'));
        const isKnownSubTab = FlowOfFundsTabs.some(
            (tab) => tab.id === requestedSubTab
        );

        setActiveSubTab(
            isKnownSubTab ? requestedSubTab : FlowOfFundsTabs[0].id
        );
    }, [props.searchParams]);

    const renderSubTabContent = () => {
        if (!activeSubTab) {
            return null;
        }
        const activeSubTabComponent = subTabComponents.find(
            (tab) => tab.id === activeSubTab
        );
        return (
            activeSubTabComponent?.content || (
                <div className="d-flex align-items-center justify-content-center mt-4">
                    <h1>Empty Tab</h1>
                </div>
            )
        );
    };

    const subTabFlagCode = (notificationFlagCode: string) =>
        `${NotificationFlagsCategories.MpCode}.${props.engagementId}.${NotificationFlagsCategories.FlowOfFundsCode}.${notificationFlagCode}`;

    return (
        <div className="flow-of-funds-tab marketplace-dynamic-container">
            <div className="RRT__container">
                <div className="RRT__tabs body-tabs">
                    {FlowOfFundsTabs.map((item) => (
                        <div
                            key={item.id}
                            className={
                                activeSubTab === item.id
                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                    : 'RRT__tab'
                            }
                            onClick={() => {
                                setActiveSubTab(item.id);
                                props.setSearchParams?.({
                                    subtab: item.id.toString(),
                                });
                            }}>
                            {item.content}
                            {item.notificationFlagCode && (
                                <NotificationFlag
                                    flagClassName="notification-flag-wrapper"
                                    eventCode={subTabFlagCode(item.notificationFlagCode)}
                                    includePrefix={true}
                                    doNotRemove={true}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {renderSubTabContent()}
        </div>
    );
};
